import Immutable from 'immutable';
import { createSelector } from 'reselect';
import { selectCurrentUser } from '../AuthSelector';

const getFlaggedContentSettings = state => state.getIn(['ui', 'contentWarnings'], Immutable.Map());

export const selectFlaggedContentVisibility = createSelector(
  [getFlaggedContentSettings, selectCurrentUser],
  (flaggedContentSettings, currentUser) => {
    // Default to true when no cookies are present (incl. server-side)
    let defaultSpoilersVisibility = flaggedContentSettings.getIn(['defaults', 'spoilersVisible']);
    let defaultOffensiveContentVisibility = flaggedContentSettings.getIn(['defaults', 'offensiveContentVisible']);

    // Overwrite with user settings to pick them up without a page refresh
    if (currentUser) {
      defaultSpoilersVisibility = !currentUser.getIn(['preferences', 'flags', 'filterSpoiler']);
      defaultOffensiveContentVisibility = !currentUser.getIn(['preferences', 'flags', 'filterOffensive']);
    }

    const individualSettings = flaggedContentSettings.delete('defaults');
    return Immutable.fromJS({
      all: { spoilersVisible: defaultSpoilersVisibility, offensiveContentVisible: defaultOffensiveContentVisibility }
    }).merge(individualSettings);
  }
);

export default selectFlaggedContentVisibility;
